import {PPResponse} from '@gongxigames/framework/integrations/pariplay/response/PPResponse';

export class PPEndGameResponse extends PPResponse {

}
